module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f07403_logo_200x200.0a32a015.png";